<template>
    <base-list-with-heading>
        <template v-slot:header>
            <span class="text-base text-gray-800">{{ day.toDateString() }}</span>
            <div class="px-4 py-1 bg-indigo-100 text-xs text-blue-800 rounded-full font-bold ml-4 hidden sm:block" v-if="day.toDateString() === today.toDateString()">
                Today
            </div>
        </template>

        <incident-list-with-heading-entry v-for="incident in incidents" :interruption="incident" :key="incident.id">
        </incident-list-with-heading-entry>
    </base-list-with-heading>
</template>

<script>
    export default {
        props: {
            day: {
                required: true,
                type: Date,
            },
            incidents: {
                required: true,
                type: Array|Object,
            },
        },
        data: function () {
            return {
                today: new Date(),
            };
        },
    }
</script>
